export enum InviteUserRolesEnum {
  ADMIN = 'admin',
  SOCIAL_MANAGER = 'social_manager',
}
